import { Fab, styled, Tooltip } from '@mui/material'
import React, { useState } from 'react'
import AddIcon from '@mui/icons-material/Add';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';


const StyledModal = styled(Modal)({
    display : "flex",
    alignItems : "center",
    justifyContent : "center"
})

export const Add = () => {

  const [open, setOpen] = useState(false);

  return (
    <>
<Tooltip  onClick={e=>setOpen(true)}
 title="Delete" sx={{position : "fixed" , bottom : 20, left :{xs:"calc(50% - 25px)", md:30}}}>
<Fab color="primary" aria-label="add">
  <AddIcon/>
</Fab>
</Tooltip>
<StyledModal
  open={open}
  onClose={e=>setOpen(false)}
  aria-labelledby="modal-modal-title"
  aria-describedby="modal-modal-description"
>
  <Box width={400} height ={250} bgcolor="white" p={3} borderRadius={5}>
  <Typography variant='h6' color="gray" textAlign="center">Create post</Typography>
  
  </Box>
</StyledModal>
    </>
  )
}
